<template>
  <!--
      Center vertically:
      For the align-items-center style to work (that is what centers
      the row vertically) it is important that both the <html> and the
      <body> has height=100%. Also all intermediate <div>'s down to
      the div with class="container" are height=100%. And using the
      h-100 style seems to be necessary.

      Center horizontally:
      Use justify-content-center on the row. Everything needs to have
      width=100% analogously.
    -->
  <div class="container h-100">
    <LoginLogout/>

    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-xs" style="text-align: center">
        <img src="../assets/Staffan.jpg" width="60px" />
        <p/>
        <h5>Video Streamer</h5>
        <h5>&copy; 2026 Staffan Kvisth</h5>
      </div>
    </div>

    <div class="sticky_footer">
      <img src="../assets/logo.jpg" width="100%"/>
    </div>
  </div>
</template>

<script>
import LoginLogout from '@/components/LoginLogout.vue'

export default {
  name: 'Profile-view',
  components: {
    LoginLogout
  },
  data() {
            return {
            }
  }
}
</script>

<style scoped lang="scss">
.about {
  text-align: center;
  position: absolute;
  top: 40%;
  left: 40%;
}

</style>
